export enum Activity {
  Passive = 0,
  Active = 1,
}
